// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Results__results___nT9uH{display:flex;flex-direction:column;padding-top:28px;padding-bottom:28px;overflow-y:auto;overflow-x:hidden}\n", ""]);
// Exports
exports.locals = {
	"results": "Results__results___nT9uH"
};
module.exports = exports;
